import React from 'react'
import './crew.css'
import engineer from './enginner.png'
const Crew = () => {
  return (
    <div className='crewsection'>
        <h1 className='meetcrew'><span>02</span>MEET YOUR CREW</h1>
        <div className='maincrew'>
            
            <div className='crewleft'>
                <h5 className='flight'>FLIGHT ENGINNER</h5>
                <h6>AHOUNOSHE ANSARI</h6>
                <p className='enginner'>Aounshoue Ansari is an iranian American engineer and Co-founder of Prodea Systems. Ansari was the fourth self funded space tourist the first self-funded woman to fly to the ISS, and the first iranian in space</p>
                 <div style={{display:'flex', justifyContent:'start', alignItems:'flex-start', gap:'20px'}} className='circles'>
                           <div style={{width:'20px', height:'20px', borderRadius:'50%', background:'gray'}} className='circle'></div>
                           <div style={{width:'20px', height:'20px', borderRadius:'50%', background:'gray'}} className='circle'></div>
                           <div style={{width:'20px', height:'20px', borderRadius:'50%', background:'gray'}} className='circle'></div>
                           <div style={{width:'20px', height:'20px', borderRadius:'50%', background:'white'}} className='circle'></div>

                
                 </div>
            </div>
            <div  className='imgboxs'>
      <img style={{width: '100%', height:'100%', objectFit:"cover"}} src={engineer} alt='ans'/>
            </div>
        </div>


    </div>
  )
}

export default Crew